import datapoints from '../datapoints';
import { createMailFolderTableQuery } from 'owa-mail-list-actions';
import {
    getFocusedFilterForTable,
    getSortByForTable,
    MailFolderTableQuery,
    listViewStore,
    getInboxClassificationFilterForTable,
    TableQueryType,
} from 'owa-mail-list-store';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import { loadTableViewFromTableQuery } from 'owa-mail-table-loading-actions';
import * as undoActions from 'owa-mail-undo';
import ViewFilter from 'owa-service/lib/contract/ViewFilter';
import { ActionSource } from 'owa-mail-store';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { startSearch, SearchScenarioId } from 'owa-search';

/**
 * Selects a filter on a current selected table view
 * @param viewFilter viewFilter to select
 * @param actionSource source of this action
 */
export default createLegacyActionWithDatapoint(
    'selectFilter',
    datapoints.selectFilter
)(function selectFilter(viewFilter: ViewFilter, actionSource: ActionSource): Promise<void> {
    const selectedTableView = getSelectedTableView();

    if (viewFilter == 'UserCategory') {
        throw new Error('ViewFilter should not be user category when select filter is called');
    }

    if (selectedTableView.tableQuery.type == TableQueryType.Search) {
        startSearch(
            'SearchFilterMenu',
            SearchScenarioId.Mail,
            true /* explicitSearch */,
            [],
            undefined,
            viewFilter
        );

        return Promise.resolve();
    } else {
        const tableQuery = createMailFolderTableQuery(
            selectedTableView.tableQuery.folderId,
            selectedTableView.tableQuery.listViewType,
            (selectedTableView.tableQuery as MailFolderTableQuery).scenarioType,
            getFocusedFilterForTable(selectedTableView),
            viewFilter,
            null /* categoryName */, // Categories and view filters ['All', 'Unread', 'To Me', 'Flagged'] cannot exist together as when a category folder is selected. The view filter needs to be set to UserCategory
            getSortByForTable(selectedTableView), // Retain the sort column when selecting filter
            getInboxClassificationFilterForTable(selectedTableView.id)
        );

        undoActions.clearLastUndoableAction();
        listViewStore.rowInfoForVLV.clear();
        listViewStore.scrollTop = 0;

        return loadTableViewFromTableQuery(
            tableQuery,
            null /* loadTableViewDatapoint */,
            actionSource
        );
    }
});
